import Com from "components/styledComp/CommStyledComp";
import React from "react";
import CompImg from "components/comp/CompImg";
import PermissionImg from "assets/images/hygateone/permission-ui.jpg";
import TimeRulesImg from "assets/images/hygateone/time-rules.jpg";

const HyGateOneSpaceSecurity = () => {
  return (
    <Com.DivDetailSection border="false" id="space-security">
      <Com.DivDetailHeading>
        <Com.DetailHeading>Smart Space Security</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          누구에게나 열린 공간이 아니라, 권한에 맞게 열리는 공간
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>공간별 권한 통제</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                멤버십 전용 공간, 임원실, 데이터센터, VIP 라운지 등<br />
                공간 성격에 맞는 출입 권한을 세밀하게 부여합니다.
              </p>
            </div>
            <CompImg img={PermissionImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>시간·규칙 관리</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                요일별·시간대별 접근 규칙과 휴일 관리로<br />
                근무 외 시간·공휴일에도 통제력을 유지합니다.
              </p>
            </div>
            <CompImg img={TimeRulesImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>보안 사고 예방</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                오피스 아워·주말·공휴일 규칙을 원천 적용해<br />
                무단 출입을 차단하고 내부 보안 사고를 최소화합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default HyGateOneSpaceSecurity;
